// Primary entry — the Container (derives the meter specs from the mock
// participant helpers and renders the View). ProgramDetail imports this as
// `ProgramProgress`, unchanged (same `program` prop).
export { ProgramProgressContainer as ProgramProgress } from "./ProgramProgressContainer";
// The props-only View — for the sim (renders with fixture meters, no mock
// reads). Never imported by ProgramDetail.
export {
    ProgramProgress as ProgramProgressView,
    type ProgramProgressProps,
    type ProgramMeter
} from "./ProgramProgress";
